import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gallery-modal-wrapper"
}
const _hoisted_2 = { class: "gallery-modal" }
const _hoisted_3 = { class: "gallery-modal__header" }
const _hoisted_4 = { class: "gallery-modal__count" }
const _hoisted_5 = { class: "gallery-modal__nav-buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "gallery-modal__title"
}
const _hoisted_9 = { class: "gallery-modal__details" }
const _hoisted_10 = { class: "image-grid-card__stage image-grid-card__stage--approved-option" }
const _hoisted_11 = { class: "gallery-modal__details-bullet" }
const _hoisted_12 = { class: "gallery-modal__buttons" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "gallery-modal__links" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return ($setup.selected_option)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString($setup.getCount()), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["gallery-modal__nav-prev", { 'gallery-modal__nav-prev--disabled': $setup.first_selected }]),
                disabled: $setup.first_selected,
                onClick: $setup.viewPrev
              }, null, 10 /* CLASS, PROPS */, _hoisted_6),
              _createElementVNode("button", {
                class: _normalizeClass(["gallery-modal__nav-next", { 'gallery-modal__nav-next--disabled': $setup.last_selected }]),
                disabled: $setup.last_selected,
                onClick: $setup.viewNext
              }, null, 10 /* CLASS, PROPS */, _hoisted_7)
            ]),
            _createElementVNode("div", null, [
              ($setup.selected_option.title)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.selected_option.related_project[0].title), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString($setup.selected_option.asset_title), 1 /* TEXT */),
                _createElementVNode("div", {
                  class: _normalizeClass([
								'image-grid-card__stage',
								$setup.getRevisionPipClass( $setup.selected_option.revision_number )
							])
                }, " Stage " + _toDisplayString($setup.selected_option.revision_number[0]), 3 /* TEXT, CLASS */),
                _createElementVNode("div", _hoisted_10, " Option " + _toDisplayString($setup.selected_option.option_number), 1 /* TEXT */),
                _createElementVNode("p", null, [
                  _createElementVNode("span", null, _toDisplayString($setup.getDate( $setup.selected_option.postDate )), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_11, " Created by " + _toDisplayString($setup.selected_option.artist?.fullName ?? 'unknown artist'), 1 /* TEXT */)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              ($props.config.downloadable && $setup.selected_option.image_url)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "gallery-modal__button",
                    href: $setup.selected_option_image_download_url
                  }, " Download ", 8 /* PROPS */, _hoisted_13))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "a kappa",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.show_tags = !$setup.show_tags))
              }, _toDisplayString($setup.show_tags == true ? 'Hide tags' : 'View tags'), 1 /* TEXT */),
              _createVNode(_component_router_link, {
                to: { name: 'projects__project', params: { project_id: $setup.selected_option.related_project[0].id } },
                class: "a kappa"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Go to project ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"]),
              _createVNode(_component_router_link, {
                to: {
							name: 'projects__project__asset',
							params: {
								project_id: $setup.selected_option.related_project[0].id,
								asset_id: $setup.selected_option.asset_id
							}
						},
                class: "a kappa"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Go to asset ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"]),
              _createElementVNode("button", {
                class: _normalizeClass(["database-grid-card__like-button database-grid-card__like-button--pill", [
							$setup.liked_options.includes( parseInt( $setup.selected_option.id ) ) ? 'database-grid-card__like-button--liked' : 'database-grid-card__like-button--unliked',
							{ 'database-grid-card__like-button--loading': $setup.loading_modal_likes }
						]]),
                disabled: $setup.loading_modal_likes,
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit( 'update-likes', $setup.selected_option.id )))
              }, _toDisplayString($setup.selected_option.likes ?? 0), 11 /* TEXT, CLASS, PROPS */, _hoisted_15)
            ]),
            _createElementVNode("button", {
              class: "gallery-modal__close-modal gallery-modal__close-modal--has-links",
              onClick: _cache[2] || (_cache[2] = $event => ($setup.emit( 'close-modal' )))
            })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["gallery-modal__content", { 'gallery-modal__content--show-sidebar': $setup.show_tags }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["gallery-modal__content-wrapper", { 'gallery-modal__content-wrapper--full-resolution': $setup.show_full_resolution }])
            }, [
              ($setup.loading)
                ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
                : _createCommentVNode("v-if", true),
              ($setup.selected_option.image_url)
                ? _withDirectives((_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: _normalizeClass(["gallery-modal__image", { 'gallery-modal__image--full-resolution': $setup.show_full_resolution }]),
                    style: _normalizeStyle($setup.full_resolution_styles),
                    src: $setup.selected_option.image_url,
                    onLoad: _cache[3] || (_cache[3] = $event => ($setup.loading = false)),
                    onClick: $setup.toggleFullResolution
                  }, null, 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_16)), [
                    [_vShow, !$setup.loading]
                  ])
                : ($setup.selected_option.video_url)
                  ? _withDirectives((_openBlock(), _createElementBlock("video", {
                      key: 2,
                      class: "gallery-modal__video",
                      src: $setup.selected_option.video_url,
                      alt: $setup.selected_option.title,
                      autoplay: "",
                      controls: "",
                      onLoadeddata: _cache[4] || (_cache[4] = $event => ($setup.loading = false))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_17)), [
                      [_vShow, !$setup.loading]
                    ])
                  : ($setup.selected_option.tour_id)
                    ? _withDirectives((_openBlock(), _createElementBlock("iframe", {
                        key: 3,
                        class: "gallery-modal__explore",
                        src: $setup.selected_option.tour_id,
                        onLoad: _cache[5] || (_cache[5] = $event => ($setup.loading = false))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_18)), [
                        [_vShow, !$setup.loading]
                      ])
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            ($setup.show_tags)
              ? (_openBlock(), _createBlock($setup["DatabaseGalleryTagsSidebarComponent"], {
                  key: 0,
                  "selected-option": $setup.selected_option,
                  onUpdateDatabaseTags: $setup.updateDatabaseTags
                }, null, 8 /* PROPS */, ["selected-option"]))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}